(function () {

    'use strict';

    angular.module('Services')
        .factory('hasDuplicate', function ($q, toastr) {
            return function (options) {
                const defer = $q.defer();
                if (options.raw && options.compareWith === options.raw) {
                    defer.resolve(false);
                    return defer.promise;
                }
                const format = {
                    success: data => {
                        let match = true;
                        if (angular.isArray(angular.getObjVal(data, options.findBy || 'content'))) {
                            match = angular.getObjVal(data, options.findBy || 'content').find(item => {
                                let itemField = angular.getObjVal(item, options.compareBy);
                                if (options.ignoreCase) {
                                    itemField = (itemField || '').toLowerCase();
                                }
                                return options.compareWith === itemField;
                            });
                        } else {
                            match = data.find(item => {
                                let itemField = item[options.compareBy];
                                if (options.ignoreCase) {
                                    itemField = (itemField || '').toLowerCase();
                                }
                                return options.compareWith === itemField;
                            })
                        }
                        if (match && options.warningMsg) {
                            toastr.warning('', options.warningMsg);
                        }
                        defer.resolve(match);
                    },
                    error: err => {
                        defer.reject(err);
                    },
                    filter: options.filters,
                    id: options.id
                };
                options.serviceCallback(format[options.callbackFormat[0]], format[options.callbackFormat[1]], format[options.callbackFormat[2]], format[options.callbackFormat[3]]);
                return defer.promise;
            }
        });
})();



// WEBPACK FOOTER //
// ./js/services/hasDuplicate.js